import TerminalsAvailability, { AvailabilitySource } from './TerminalsAvailability';

// Terminals > Availability. The shared availability table (TerminalsAvailability) fed by the backend's ServiceNow
// endpoint. The browser never talks to ServiceNow, and no credentials reach this code.
const SERVICENOW_SOURCE: AvailabilitySource = {
  endpoint: '/api/apmt/servicenow-availability',
  title: 'Terminals — Availability',
  showPreviousYear: true,
};

export default function TerminalsServiceNowAvailability() {
  return <TerminalsAvailability source={SERVICENOW_SOURCE} />;
}
